import React, { Component } from "react";
import '../assets/templates/TextPagesIllustrated.css';
import LessonInstruction from "../containers/instruction/LessonInstruction";

class TextPagesIllustrated extends Component {
  constructor(props) {
    super(props)

    this.state = {
        language: 'en'
    }
  }

  getImageUrl(name){
      return `${process.env.REACT_APP_CLOUDFRONT_DNS}/media/images/` + name
  }

  render() {
    const { blockData, contentIndex, audioUrl } = this.props;

    // temporary - sets background to white color
    const bgColor = blockData.content[contentIndex].type === "instruction" ? "new-bg-color" : "";
    const containerClasses = `default-card ${bgColor}`;

    return (
      <div className={containerClasses}>
        {
            blockData.content[contentIndex].type === 'instruction' ?
            <>
                <LessonInstruction
                    instructionText={blockData.content[contentIndex].instruction}
                    audioUrl={audioUrl}
                />
            </>
            :
            <div className="illustrated-container">
                <img className="illustrated-img" alt="TextIllustrated" src={this.getImageUrl(blockData.complement.img.img)} />
                <div className="illustrated-pages-container">
                    <div className="change-language-container" >
                        <div 
                            className="language-select" 
                            style={{ backgroundColor: this.state.language === 'en' ? 'red' : 'rgb(65,182,230)' }}
                            onClick={() => this.setState({ language: 'en' })}>
                            EN
                        </div>
                        <div 
                            className="language-select" 
                            style={{ backgroundColor: this.state.language === 'pt' ? 'red' : 'rgb(65,182,230)' }}
                            onClick={() => this.setState({ language: 'pt' })}>
                            PT
                        </div>
                    </div> 
                    <div style={{fontSize: 32, color: 'rgb(97,97,97)'}}>
                        {
                            this.state.language === 'en'
                                ? blockData.content[contentIndex].titleEn
                                : blockData.content[contentIndex].titlePt
                        }
                    </div>
                    <div>
                        {
                            this.state.language === 'en'
                                ? blockData.content[contentIndex].en
                                : blockData.content[contentIndex].pt
                        }
                    </div>
                </div>
            </div>
            
        }
      </div>
    )
  }
}

export default TextPagesIllustrated;
